import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47ca570c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "container-centered"
}
const _hoisted_4 = {
  key: 1,
  class: "k-tap-gradient-container",
  style: {"height":"100%"}
}

import * as GameTypes from 'types/game.types';
import { ref } from 'vue';
import { useMotions } from '@vueuse/motion'
import { useModule } from 'src/modules/modules';
import { getGameSetTransitions, gameSetLeave } from '../transitions';
import Draggable from "vuedraggable";
import DoneButton from '../done-button.vue';
import GameContentArea from '../game-content-area.vue';
import ColorButton from '../color-button.vue';
import GradientShape from '../gradient-shape.vue';
import { getColorWithSimilarityInRange, getRandomNonUglyColor, interpolate } from 'util/color-util';
import shuffle from 'lodash/shuffle';
import chroma from 'chroma-js';
import { random, sample } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'order-gradient',
  props: {
    difficulty: {
        type: Number,
        default: 0
    }
},
  emits: ['next', 'fail'],
  setup(__props, { expose, emit }) {

const props = __props

const { game, audio } = useModule();


const dragging = ref(false);


const variation = ref(1);
const stateVariation1 = ref({
    distanceMin: 20,
    distanceMax: 30,
    gradientCount: 8,
    duration: 15000
})

const stateVariation2 = ref({
    swapCount: 4,
    gridSize: 6,
    duration: 60000
})

const gradientColors = ref<chroma.Color[]>([]);
const gradientColorsShuffled = ref<chroma.Color[]>([]);
const selectedColors = ref<chroma.Color[]>([]);

if (props.difficulty === 0){
    variation.value = 1;
    stateVariation1.value = {
        distanceMin: 20,
        distanceMax: 30,
        gradientCount: 5,
        duration: 10000
    }
} else if (props.difficulty === 1){
    variation.value = sample([1, 2])!;
    if (variation.value === 1){
        stateVariation1.value = {
            distanceMin: 20,
            distanceMax: 35,
            gradientCount: 8,
            duration: 15000
        }
    } else {
        stateVariation2.value = {
            swapCount: 2,
            gridSize: 5,
            duration: 30000
        }
    }

} else if (props.difficulty === 2){
    variation.value = sample([1, 2])!;
    if (variation.value === 1){
        stateVariation1.value = {
            distanceMin: 60,
            distanceMax: 100,
            gradientCount: 10,
            duration: 20000
        }
    } else {
        stateVariation2.value = {
            swapCount: 3,
            gridSize: 6,
            duration: 45000
        }
    }
} else if (props.difficulty === 3){
    variation.value = 2;
    stateVariation2.value = {
        swapCount: 4,
        gridSize: 6,
        duration: 60000
    }
} else if (props.difficulty === 4){
    variation.value = 2;
    stateVariation2.value = {
        swapCount: 5,
        gridSize: 7,
        duration: 60000
    }
} else if (props.difficulty >= 5){
    variation.value = 2;
    stateVariation2.value = {
        swapCount: 8,
        gridSize: 8,
        duration: 80000
    }
}

if (variation.value === 1){
    let c1 = getRandomNonUglyColor();
    let c2 = getColorWithSimilarityInRange(c1, stateVariation1.value.distanceMin, stateVariation1.value.distanceMax);
    gradientColors.value = interpolate(c1, c2, stateVariation1.value.gradientCount);
    gradientColorsShuffled.value = shuffle(gradientColors.value);
} 

const testOrder = (arr: chroma.Color[]) => {
    return gradientColors.value.reduce((acc, curr, i) => {
        if (curr !== arr[i]){
            acc = false;
        }
        return acc;
    }, true);
}

const handleColorSelected = (color: chroma.Color) => {
    if (selectedColors.value.includes(color)){
        selectedColors.value = selectedColors.value.filter(c => c !== color);
        return;
    }

    selectedColors.value.push(color);
}

const doneBtn = ref();
const container = ref();
const leave = () => {
    if (variation.value === 1){
        return Promise.all([
            gameSetLeave(useMotions()),
            container?.value.leave(),
            doneBtn.value?.leave()
        ]);
    } else {
        return Promise.all([
            container?.value.leave(),
            gradientShape.value?.leave(),
            doneBtn.value?.leave()
        ]);
    }
}

const gradientShape = ref();
const handleCheckOrder = async () => {
    let valid = false;
    if (variation.value === 1){
        valid = testOrder(gradientColorsShuffled.value) || testOrder([...gradientColorsShuffled.value].reverse());
    } else if (variation.value === 2){
        valid = gradientShape.value?.isOrderValid()
    }

    if (valid){
        emit('next', <GameTypes.MatchCompleteData> {
            baseScore: 50,
            background: gradientColors.value[0]
        });
        return;
    }
    emit('fail');
}

const started = ref(false);
const handleVariation1Enter = (index: number) => {
    let count = stateVariation1.value.gradientCount - 1;
    if (started.value === false && index === count){
        started.value = true;
        game.clock.start(stateVariation1.value.duration);
    }
}

const handleVariation2Enter = () => {
    game.clock.start(stateVariation2.value.duration);
}

expose({
    leave
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    onSkip: _cache[2] || (_cache[2] = () => emit('next', { skipped: true }))
  }, {
    instruction: _withCtx(() => [
      (variation.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Drag the colors into order! "))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, " Swap the tiles until the gradient is repaired! "))
    ]),
    content: _withCtx(() => [
      (variation.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(GradientShape, {
              ref_key: "gradientShape",
              ref: gradientShape,
              class: "mb4",
              "grid-count": stateVariation2.value.gridSize,
              "swap-count": stateVariation2.value.swapCount,
              onEnter: handleVariation2Enter
            }, null, 8, ["grid-count", "swap-count"]),
            _createVNode(DoneButton, {
              ref_key: "doneBtn",
              ref: doneBtn,
              width: "25%",
              onClick: handleCheckOrder
            }, null, 512)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(Draggable), {
              list: gradientColorsShuffled.value,
              animation: 200,
              "item-key": "rgba",
              class: "k-tap-gradient-colors mb3",
              onStart: _cache[0] || (_cache[0] = ($event: any) => (dragging.value = true)),
              onEnd: _cache[1] || (_cache[1] = ($event: any) => (dragging.value = false))
            }, {
              item: _withCtx(({ element, index }) => [
                _withDirectives(_createVNode(ColorButton, _mergeProps({
                  color: element.hex(),
                  class: "k-tap-gradient-btn",
                  onClick: () => handleColorSelected(element)
                }, _unref(getGameSetTransitions)(index, { onComplete: handleVariation1Enter })), null, 16, ["color", "onClick"]), [
                  [_directive_motion, `btnMotion${index}`]
                ])
              ]),
              _: 1
            }, 8, ["list"]),
            _createVNode(DoneButton, {
              ref_key: "doneBtn",
              ref: doneBtn,
              width: "25%",
              onClick: handleCheckOrder
            }, null, 512)
          ]))
    ]),
    _: 1
  }, 512))
}
}

})